import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Switch from '@mui/material/Switch';
import { Button } from "../../../UI/MUIButton";
import { NetworkPortfolio } from "../../../components/NetworkPortfolio";

import { useNetwork } from "../../../hooks/useNetwork";

import { MainLayout } from "../../../layout/MainLayout";
import { useNetworkRename } from "./useNetworkRename";
import { CreateNetworkModal } from "../network_settings/modals/CreateNetworkModal";
import { EditWrapper } from "../../../components/EditWrapper";
import { NetworkImportType } from "../../../components/NetworkImportType";
import { SubnetworksTree } from "../../../components/SubnetworksTree";
import useAuth from "../../login/AuthContext";
import { LoadAllPortfolios, Portfolio } from "../../../services/PortfolioApi";
import {NetworkEnabled} from "../../../components/NetworkEnabled";
import {NetworkBioEnabled} from "../../../components/NetworkBioEnabled";

export const NetworkCreationContainer: React.FunctionComponent = () => {
  const { getAuthToken } = useAuth();
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);
  const { selectedNetwork } = useNetwork();
  const { isSuperAdmin, isSuperAdminWrite, isSuperAdminRead } = useAuth();
  const handleRename = useNetworkRename();
  const [isNetworkCreationModal, setIsNetworkCreationModal] = useState(false);
  const [ showArchived, setShowArchived ] = useState<boolean>(false);
  const handleTogglChange = (_: any, checked: boolean) =>setShowArchived(checked);
  

  useEffect(() => {
    const load = async () => {
      const results = await LoadAllPortfolios(0, await getAuthToken());
      if (results?.content) {
        setPortfolios(results?.content);
      }
    };

    load();
  }, []);

  return (
    <MainLayout
      title="Network Creation"
      endAdornment={
        isSuperAdmin() && (
          <>
            <Button
              color="primary"
              variant="contained"
              disabled={isSuperAdminRead()}
              onClick={() => setIsNetworkCreationModal(true)}
            >
              Create a new network
            </Button>
            <CreateNetworkModal
              show={isNetworkCreationModal}
              onClose={() => setIsNetworkCreationModal(false)}
              portfolios={portfolios}
            />
          </>
        )
      }
    >
      {!!selectedNetwork.l1Id && isSuperAdmin() && (<>
        <Grid container spacing={2} alignItems="stretch" justifyContent="space-between">
          <Grid item xs={6}>
            {isSuperAdminWrite() && (
              <EditWrapper
                defaultValue={selectedNetwork.l1Name}
                onEditSuccess={handleRename}
              >
                <Typography variant="h4" gutterBottom>
                  {selectedNetwork.l1Name}
                </Typography>
              </EditWrapper>
            )}
            {isSuperAdminRead() && (
              <Typography variant="h4" gutterBottom>
                {selectedNetwork.l1Name}
              </Typography>
            )}
            <NetworkImportType isPreview={isSuperAdminRead()} />
            <NetworkPortfolio isPreview={isSuperAdminRead()} portfolios={portfolios} />
            <NetworkEnabled isPreview={isSuperAdminRead()} />
            <NetworkBioEnabled isPreview={isSuperAdminRead()} />
          </Grid>
          <Grid item>
          <Typography> Show Archived
            <Switch value={showArchived} onChange={handleTogglChange}/>
          </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SubnetworksTree isPreview={isSuperAdminRead()} showArchived={showArchived} />
          </Grid>
        </Grid>
        </>)}
    </MainLayout>
  );
};

export const NETWORK_CREATION = "/super_admin/network_creation";
